module.exports = __webpack_public_path__ + "static/media/monitoring.86524a5a.svg";